import { render, staticRenderFns } from "./SwitchSchool.vue?vue&type=template&id=8fc81e68&"
import script from "./SwitchSchool.vue?vue&type=script&lang=js&"
export * from "./SwitchSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports